<template>
  <nav class="dsb" :class="{ 'dsb--collapsed': collapsed }" aria-label="Разделы панели диспетчера">
    <div class="dsb__head">
      <span v-if="!collapsed" class="dsb__title">Диспетчер</span>
      <button
        type="button"
        class="btn btn-sm btn-light dsb__toggle"
        :aria-label="collapsed ? 'Развернуть меню' : 'Свернуть меню до иконок'"
        :aria-expanded="String(!collapsed)"
        @click="$emit('toggle')"
      >
        <i class="ri-menu-line"></i>
      </button>
    </div>
    <ul class="dsb__list list-unstyled mb-0">
      <li v-for="s in sections" :key="s.key">
        <button
          type="button"
          class="dsb__item"
          :class="{ 'dsb__item--active': s.routeName === activeRouteName }"
          :aria-current="s.routeName === activeRouteName ? 'page' : null"
          :title="collapsed ? s.label : null"
          @click="$emit('select', s)"
        >
          <i :class="s.icon" class="dsb__icon" aria-hidden="true"></i>
          <span v-if="!collapsed" class="dsb__label">{{ s.label }}</span>
        </button>
      </li>
    </ul>
  </nav>
</template>

<script>
export default {
  name: 'DispatcherSidebar',
  props: {
    sections: { type: Array, required: true },
    collapsed: { type: Boolean, default: false },
    activeRouteName: { type: String, default: '' },
  },
};
</script>

<style scoped lang="scss">
.dsb {
  width: 230px;
  flex: none;
  background: #fff;
  border-right: 1px solid #e3e5e1;
  padding: 12px;
  display: flex;
  flex-direction: column;
  gap: 4px;
  &--collapsed { width: 62px; padding: 12px 8px; }
}
.dsb__head { display: flex; align-items: center; justify-content: space-between; padding: 0 2px 8px; }
.dsb__title { font-size: 10.5px; letter-spacing: .1em; text-transform: uppercase; color: #9aa09b; font-weight: 800; padding-left: 8px; }
.dsb__toggle { line-height: 1; }
.dsb__item {
  appearance: none; border: 0; background: transparent; cursor: pointer; width: 100%; text-align: left;
  display: flex; align-items: center; gap: 10px; padding: 10px 11px; border-radius: 9px;
  font-size: 13.5px; font-weight: 600; color: #4c524d;
  &:hover { background: #f4f5f1; }
  &:focus-visible { outline: 2px solid #17876f; outline-offset: 1px; }
  &--active { background: #f2f9f6; color: #0f5a4a; font-weight: 800; }
  .dsb--collapsed & { justify-content: center; padding: 11px 0; }
}
.dsb__icon { font-size: 18px; line-height: 1; }
.dsb__label { white-space: nowrap; }
</style>
